export default {"src":"/_next/static/media/dai.d1f545a1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};